<template>
  <Layout>
    <Sider class="sidebar">
      <LeftTree @OnSelectChange="showmap"></LeftTree>
    </Sider>
    <Layout>
    <Content  class="content">
    <MyRoadMap ref="myroad"></MyRoadMap>
   <!--  <FileRange :style="{display:rangehidden?'none':'block'}"></FileRange> -->
    <Card>
        <div style="height: auto;">
         <router-view v-if="isRouterAlive"></router-view>
      </div>
    </Card>
    </Content>
    </Layout>
  </Layout>
</template>
<script>
import Vue from 'vue'
import LeftTree from './left_tree.vue'
import RoadMap from './../road_map.vue'
export default {
  name: 'SearchMain',
  data() {
    return {
      isRouterAlive:false,
      rangehidden:true,//是否显示适用范围
    }
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  methods: {
    showmap(maps) {
      //console.log(maps);
      var len
      if(maps!==undefined && maps.length>0){
         len=maps.length
      }
      //console.log(maps)
      this.$refs.myroad.listen(maps);
      //go
      this.$router.push({
        name: 'identicalContent',
        query: {
          classid: maps[len-1].id,
        }
      })
      this.reload()
    },
    reload() {
      this.isRouterAlive = false
      //在修改数据之后使用 $nextTick，则可以在回调中获取更新后的 DOM
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    },

  },
  components: {
    'LeftTree': LeftTree,
    'MyRoadMap': RoadMap,
  }
}

</script>
<style lang="less" scoped>
.sidebar {
  background: #fff;
  overflow: auto;
  Height: 740px;
}
.content{
  padding: 0 0 0 10px;
  Height: 740px; 
  background: #fff;
}
</style>
